export class SmsAsideDto {
    public phone: string;
    public phoneReadonly: boolean;
    public text: string;
    public textFixed: boolean;
    public message: string;

    public static build(phone: string, phoneReadonly: boolean, text: string, textFixed: boolean): SmsAsideDto {
        const d = new SmsAsideDto();
        d.phone = phone;
        d.phoneReadonly = phoneReadonly;
        d.text = text;
        d.textFixed = textFixed;
        d.message = '';
        return d;
    }
}
